import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

import {
  RequisitionsAbilities,
  RequisitionsDataProviderService,
} from '../../data/single-requisition/requisitions-data-provider.service';

@Injectable()
export class HiresFacade {
  private abilities: RequisitionsAbilities;
  private isRequisitionReadOnly: boolean;
  private ngOnDestroy$ = new Subject<void>();

  constructor(
    protected store: Store,
    protected requisitionsData: RequisitionsDataProviderService,
  ) {
    requisitionsData.data$
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(({ abilities, isRequisitionReadOnly }) => {
        this.abilities = abilities;
        this.isRequisitionReadOnly = isRequisitionReadOnly;
      });
  }

  public get canUnassignCandidates(): boolean {
    return this.abilities.manageRequisitions && !this.isRequisitionReadOnly;
  }

  public get canViewCandidateProfile(): boolean {
    return this.abilities.viewHiredCandidates;
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
